import { type ComponentProps, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type AssetModalContentFooterProps = ComponentProps<'footer'>;

export const AssetModalContentFooter = memo(({ className, ...restOfProps }: AssetModalContentFooterProps) => {
  return (
    <footer
      className={cn('flex size-full shrink-0 items-center justify-center', className)}
      data-testid="ASSET_MODAL_CONTENT_FOOTER"
      {...restOfProps}
    />
  );
});

AssetModalContentFooter.displayName = 'AssetModalContentFooter';
